import React, { Fragment, useState } from 'react';
import { DEFAULT_OWNERSHIP_VALUE } from './const';

export default function IsOwner({
  onChange,
}: {
  onChange: (isOwner: boolean) => void;
}): JSX.Element {
  const [isChecked, setIsChecked] = useState(false);
  return (
    <Fragment>
      <div className='md:w-1/3 my-2'>
        <p className='md:w-full my-2'>
          Do you own {DEFAULT_OWNERSHIP_VALUE}% or more of the business?
        </p>
      </div>
      <ul className='md:w-1/3 my-2'>
        <li>
          <input
            type='radio'
            checked={!isChecked}
            value='no'
            id='owner-no'
            onChange={(e) => {
              setIsChecked(e.target.value === 'yes');
              onChange(e.target.value === 'yes');
            }}
          />
          <label className='text-sm font-medium' htmlFor='owner-no'>
            No
          </label>
        </li>
        <li>
          <input
            type='radio'
            checked={isChecked}
            value='yes'
            id='owner-yes'
            onChange={(e) => {
              setIsChecked(e.target.value === 'yes');
              onChange(e.target.value === 'yes');
            }}
          />
          <label className='text-sm font-medium' htmlFor='owner-yes'>
            Yes
          </label>
        </li>
      </ul>
    </Fragment>
  );
}
